export default __webpack_public_path__ + "static/media/Freebooter's Belt of Crouching Calm.9b100db6.jpg";